<template>
  <div>
    <div
      style="position: fixed; bottom: 0; width: 100vw; z-index: 1000; overflow:hidden; background: white; font-size: 16px; border-top: 1px solid #fafafa;"
    >
      <div
        v-for="(nav, index) in bottomNav"
        :key="index"
        :class="nav.selected ? 'selected' : ''"
        :style="{
          'font-size': '18px',
          width: '49vw',
          'text-align': 'center',
          float: 'left',
          'line-height': '50px',
          'border-right':
            index !== bottomNav.length - 1 ? '1px solid #f0f0f0' : ''
        }"
        @click="onNavClicked(nav)"
      >
        <i :class="nav.icon"></i>
        {{ nav.name }}
      </div>
    </div>
    <div style="height: 50px;"></div>
  </div>
</template>

<script>
const delta = 15;

export default {
  name: "bottomNav",
  props: {
    navListProp: {
      type: null
    }
  },
  components: {},
  watch: {
    navListProp: function(val) {
      console.log(val, "val");
    },
    $route(to, from) {
      // react to route changes...
      this.changeBtnStatus();
      console.log(to, "routerto");
    }
  },
  data() {
    return {
      bottomNav: []
    };
  },
  created() {
    this.bottomNav = this.navListProp;

    this.changeBtnStatus();
  },
  methods: {
    changeBtnStatus() {
      const _path = this.$router.currentRoute.path;
      this.bottomNav.forEach((item, i) => {
        item.selected = false;
      });

      if (_path === "/index") {
        this.bottomNav[0]["selected"] = true;
      } else {
        this.bottomNav[1]["selected"] = true;
      }
    },
    onNavClicked(nav) {
      this.bottomNav.forEach((item, i) => {
        item.selected = false;
      });
      nav.selected = !nav.selected;
      const _path = this.$router.currentRoute.path;
      if (nav.path !== _path) {
        this.$router.push({ path: nav.path });
      }
      console.log(this.$router.currentRoute);
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import "../../../styles/variables.scss";

.scroll-container {
  position: relative;
  width: 100%;
  height: 100%;
  background-color: $menuBg;
  .scroll-wrapper {
    position: absolute;
    width: 100% !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/components/website/bottomNav.vue